import { Injectable } from '@angular/core';
import { System } from './system-context.service';

export interface SystemSettings {
  systemTitle?: string;
  topbarIconUrl?: string;
  brandLogoUrl?: string;
  loginImageUrl?: string;
  moduleCardsImages?: Record<string, string>;
  modulesEnabled?: Record<string, boolean>;
}

const DEFAULTS: SystemSettings = {
  systemTitle: 'Sistema',
  moduleCardsImages: {},
  modulesEnabled: {}
};

@Injectable({ providedIn: 'root' })
export class SystemSettingsService {
  private storageKey(system: System) {
    const sys = system || 'hse';
    return `system_settings_${sys}`;
  }

  get(system: System): SystemSettings {
    try {
      const raw = localStorage.getItem(this.storageKey(system));
      if (!raw) return { ...DEFAULTS };
      const obj = JSON.parse(raw);
      return { ...DEFAULTS, ...(obj || {}) } as SystemSettings;
    } catch (e) {
      return { ...DEFAULTS };
    }
  }

  update(system: System, patch: Partial<SystemSettings>): SystemSettings {
    const current = this.get(system);
    const next: SystemSettings = { ...current, ...(patch || {}) };
    localStorage.setItem(this.storageKey(system), JSON.stringify(next));
    return next;
  }

  setModuleEnabled(system: System, moduleKey: string, enabled: boolean): SystemSettings {
    const current = this.get(system);
    const map = { ...(current.modulesEnabled || {}) };
    map[moduleKey] = enabled;
    return this.update(system, { modulesEnabled: map });
  }

  isModuleEnabled(system: System, moduleKey: string, defaultValue: boolean = true): boolean {
    const current = this.get(system);
    const val = current.modulesEnabled?.[moduleKey];
    return typeof val === 'boolean' ? val : defaultValue;
  }
}
